var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    clipPath: "url(#clip0_936_1797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 3.64089C19.7477 3.97742 18.952 4.2011 18.1375 4.30502C18.9959 3.7827 19.6376 2.95559 19.9412 1.98043C19.1376 2.46917 18.2585 2.81339 17.3418 2.9982C16.1914 1.73763 14.4065 1.32647 12.8409 1.96141C11.2753 2.59635 10.2474 4.14831 10.2488 5.87488C10.2457 6.19685 10.2775 6.51816 10.3438 6.83288C7.04478 6.667 3.97093 5.06733 1.89245 2.43465C0.797259 4.35475 1.34895 6.81739 3.15149 8.05474C2.50274 8.03676 1.8677 7.85912 1.29989 7.53679V7.58261C1.30209 9.58418 2.67369 11.3094 4.58496 11.7147C4.23418 11.8095 3.87266 11.8561 3.50991 11.8532C3.24943 11.8579 2.98922 11.8338 2.73377 11.7813C3.27683 13.4915 4.81187 14.6651 6.5651 14.7105C5.11377 15.8745 3.32387 16.506 1.48144 16.504C1.15342 16.5062 0.825605 16.4869 0.5 16.4461C2.37484 17.6851 4.55953 18.3406 6.7899 18.3332C14.3348 18.3332 18.46 11.9236 18.46 6.36763C18.46 6.18165 18.4537 6.00234 18.4449 5.82407C19.2537 5.23051 19.9501 4.49068 20.5 3.64089Z",
    fill: "#03A9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_1797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.d40625feafa42eb585bb707960f5e815.svg";
export { ForwardRef as ReactComponent };